//#region src/domain/i18n/currency-code.ts
var CurrencyCode = /* @__PURE__ */ function(CurrencyCode) {
	CurrencyCode["DOP"] = "DOP";
	CurrencyCode["GTQ"] = "GTQ";
	CurrencyCode["HNL"] = "HNL";
	return CurrencyCode;
}({});
//#endregion
export { CurrencyCode };

//# sourceMappingURL=currency-code.js.map